import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ClockCounterClockwise = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke="#3379BD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 7.5V12l3.75 2.25m-9-4.5H3m0 0V6m0 3.75c1.151-1.413 2.063-2.466 3.166-3.584A8.25 8.25 0 1 1 6.337 18"
    />
  </Svg>
);
export default ClockCounterClockwise;
